import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const TEAM = [
  {
    name: "Rupert Chue Jnr.",
    title: "Chief Executive Officer",
    image: "https://1141bc.com/images/team/RuperChueJnr.jpg",
    bio: "20+ years of business experience spanning distribution, retail, remittance, and property development across Jamaica.",
  },
  {
    name: "Sean Chue",
    title: "Chief Operating Officer",
    image: "https://1141bc.com/images/team/SeanChue.jpg",
    bio: "Oversees facility operations, regulatory compliance, and ensures each unit meets functional and aesthetic client needs.",
  },
  {
    name: "Janielle Chue",
    title: "Chief Creative & Marketing Officer",
    image: "https://1141bc.com/images/team/JanielleChue.jpg",
    bio: "Leads branding, marketing strategy, and creative direction to drive tenant engagement and market presence.",
  },
  {
    name: "Kerwin Hamil",
    title: "Consulting CFO",
    image: "https://1141bc.com/images/team/KerwinHamil.jpg",
    bio: "Fellow Chartered Accountant and CPA with extensive expertise in corporate finance, risk management, and strategic planning.",
  },
];

export default function TeamSection() {
  return (
    <section id="team" data-testid="team-section" className="bg-[#182649] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-14">
          <span
            className="text-xs font-semibold tracking-[0.2em] uppercase text-[#D49A38] block"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="team-overline"
          >
            Leadership
          </span>
          <div className="w-12 h-[2px] bg-[#D49A38] mt-4 mb-6" />

          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white tracking-tight leading-[1.1] uppercase"
            style={{ fontFamily: "Outfit, sans-serif" }}
            data-testid="team-headline"
          >
            The team behind the <span className="text-[#D49A38]">vision</span>
          </h2>

          <p
            className="mt-5 text-base md:text-lg text-white/70 leading-relaxed"
            style={{ fontFamily: "Manrope, sans-serif" }}
            data-testid="team-intro"
          >
            Tailwind Corporation is supported by an experienced team of business, finance, design, and project professionals helping bring high quality commercial developments to life.
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TEAM.map((member) => (
            <div
              key={member.name}
              className="bg-white/5 border border-white/10 rounded-md overflow-hidden hover:bg-white/10 transition-colors duration-300"
              data-testid={`team-card-${member.name.toLowerCase().replace(/[\s.]+/g, "-")}`}
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5">
                <h3
                  className="text-base font-bold text-white"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {member.name}
                </h3>
                <p
                  className="text-sm font-semibold text-[#D49A38] mt-1"
                  style={{ fontFamily: "Manrope, sans-serif" }}
                >
                  {member.title}
                </p>
                <p
                  className="text-sm text-white/50 leading-relaxed mt-3"
                  style={{ fontFamily: "Manrope, sans-serif" }}
                >
                  {member.bio}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-12 text-center">
          <Button
            asChild
            className="bg-[#D49A38] text-white hover:bg-[#c08a2e] rounded-full px-8 py-6 text-base font-semibold transition-all duration-300 shadow-lg"
            data-testid="team-cta-button"
          >
            <a href="https://1141bc.com/units" target="_blank" rel="noopener noreferrer">
              Browse Available Units
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
